export enum EditViewEnum {
    Chapter = 'chapter',
    Label = 'label',
    Paint = 'paint',
    Position = 'position'
}
